import { getConfig } from '../../../config';
import { isMultiManageSite } from '../../../lib';

const SiteKeyMap: Record<string, string> = {
  'woa-test': 'DEV',
  'woa-test-idc': 'IDC',
};

export const getTableID = (record: {
  site?: string;
  id: number;
  [id: string]: any;
}) => {
  if (
    !isMultiManageSite() ||
    getConfig().multiSiteDataSourcesConfig?.length === 1
  ) {
    return record.id;
  }

  if (!record.site) {
    return record.id;
  }

  const siteKeyArr = record.site?.split('-') || [];
  siteKeyArr.pop();
  let siteKey = siteKeyArr.join('');
  if (!siteKey) {
    return record.id;
  }

  siteKey = SiteKeyMap[record.site] || siteKey.replace(/^woa/, 'oa');
  return `${String(siteKey).toUpperCase()}${record.id}`;
};
